<app-modal [modalConfig]="modalConfig">
  <div class="config-report-groups" *ngIf="!isLoading">
    <div class="input-container">
      <label>Buscar grupo de reportes</label>
      <section class="report-group-search">
      <app-dynamic-typeahead [editable]="false" [control]="queryControl" [method]="reportGroupsUrl" [maxQuantity]="5"
        prop="nombre" [resetInput]="true" (selectEvent)="addReportGroup($event)" class="search-typeahead">
      </app-dynamic-typeahead>
      <button class="btn-gray" [disabled]="isLoading" *ngIf="checkAdminRole()" (click)="addAllReportGroups()">Agregar todos</button>
    </section>
    </div>
    <div class="multiple-values" *ngIf="selectedReportGroups.length >0">
      <span *ngFor="let item of selectedReportGroups" (click)="removeReportGroup(item)">
        <ng-container [ngTemplateOutlet]="defaultValue" [ngTemplateOutletContext]="{value:item.nombre}">
        </ng-container>
        <fa-icon class="arrow-icon" [icon]="faCircleXmark"></fa-icon>
      </span>
    </div>
    <div class="empty" *ngIf="selectedReportGroups.length === 0">
      ¡No se han asignado grupos de reportes!
    </div>

    <ng-template #defaultValue let-value='value'>
      {{ value }}
    </ng-template>

    <button class="btn-submit" [disabled]="isLoading" (click)="saveReportGroupList()">Guardar
    </button>
  </div>
  <div class="loader" [hidden]="!isLoading">
    <ngx-ui-loader loaderId="report-group-to-user" [hasProgressBar]="false"></ngx-ui-loader>
  </div>
</app-modal>